import React, { type CSSProperties } from 'react'
import ButtonGroup, { type ButtonGroupProps } from '@mui/material/ButtonGroup'
import { buttonColorMap } from './buttonColorMap'

export type StyledButtonGroupProps = ButtonGroupProps & {
    minWidth?: CSSProperties['minWidth']
}

export function StyledButtonGroup({
    variant = 'contained',
    color = 'primary',
    sx,
    children,
    minWidth = 'unset',
    ...rest
}: StyledButtonGroupProps) {
    const brandedColor = buttonColorMap[color as keyof typeof buttonColorMap]

    return (
        <ButtonGroup
            variant={variant}
            color={color}
            {...rest}
            sx={[
                {
                    '& .MuiButtonGroup-grouped': {
                        minWidth: minWidth ?? 'undefined',
                    },
                    ...(brandedColor
                        ? {
                              '& > .MuiButton-root': {
                                  borderColor: brandedColor.border,
                              },
                          }
                        : {}),
                },
                ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
            ]}
        >
            {children}
        </ButtonGroup>
    )
}
